import { j as o } from "../../../../jsx-runtime-B6kdoens.js";
import { forwardRef as s } from "react";
import { I as e } from "../../../../IconBase-CxZyIWw2.js";
const n = s((r, t) => /* @__PURE__ */ o.jsx(
  e,
  {
    ref: t,
    ...r,
    image: (i) => /* @__PURE__ */ o.jsxs(
      "svg",
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 48,
        height: 48,
        fill: "none",
        viewBox: "0 0 48 48",
        ...i,
        children: [
          /* @__PURE__ */ o.jsx(
            "path",
            {
              fill: "currentColor",
              d: "M24 40c-8.82 0-16-7.18-16-16S15.18 8 24 8s16 7.18 16 16-7.18 16-16 16m0-30.5C16 9.5 9.5 16 9.5 24S16 38.5 24 38.5 38.5 32 38.5 24 32 9.5 24 9.5"
            }
          ),
          /* @__PURE__ */ o.jsx(
            "path",
            {
              fill: "currentColor",
              d: "M29.92 32.88c-1.24 0-1.88-.87-2.35-1.51-.39-.53-.59-.76-.85-.76-.34 0-.48.17-.84.79-.34.59-.86 1.49-2.04 1.49-1.09 0-1.59-.86-1.94-1.49-.35-.61-.5-.8-.76-.8-.2 0-.38.23-.7.72-.43.66-1.02 1.57-2.28 1.57-.41 0-.75-.34-.75-.75s.34-.75.75-.75c.4 0 .61-.26 1.02-.89.39-.59.92-1.4 1.95-1.4 1.18 0 1.71.94 2.07 1.56.31.54.45.73.64.73.28 0 .41-.16.74-.74.35-.61.88-1.54 2.14-1.54 1.05 0 1.61.76 2.06 1.37.46.63.71.9 1.14.9.41 0 .75.34.75.75s-.34.75-.75.75"
            }
          )
        ]
      }
    )
  }
));
n.displayName = "AgencyMildIrritationIcon";
export {
  n as AgencyMildIrritationIcon,
  n as default
};
//# sourceMappingURL=index.js.map
